import { render, staticRenderFns } from "./CountBox.vue?vue&type=template&id=35ec665e&scoped=true"
import script from "./CountBox.vue?vue&type=script&lang=js"
export * from "./CountBox.vue?vue&type=script&lang=js"
import style0 from "./CountBox.vue?vue&type=style&index=0&id=35ec665e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ec665e",
  null
  
)

export default component.exports